import { Row } from "@tanstack/react-table"
import { KrEndangeredAreaFormTypes, KrLandslideFormTypes } from "../../../../../../contexts/krFormContext"
import { poFormTypes } from "../../../../../../contexts/poFormContext"
import { Dictionary } from "../../../../../../helpers/dictionariesFromLayers"
import { Cards } from "../../../../../../services/registrationCardService/types/registrationCardServiceProps"

export type AutomaticVerificationModalProps = {
    cards?: Cards | null,
    rows?: Row<any>[],
    triggeredFromLocal?: boolean
}

export enum TypeOfCard {
    landslide = 1,
    endangeredArea = 2,
    protocol = 3
}

export enum TypeOfValidation {
    error = 1,
    warning = 2,
    valid = 3
}

export type AutomaticVerificationSingleTabProps = {
    card?: KrLandslideFormTypes | KrEndangeredAreaFormTypes | poFormTypes,
    type?: number,
    rows?: Row<any>[],
    triggeredFromLocal?: boolean,
    dictionariesForValidation?: Dictionary
}

export type OptionsForCards = {
    name?: string,
    validationType: TypeOfValidation,
    card?: KrLandslideFormTypes | KrEndangeredAreaFormTypes | poFormTypes,
    cardType?: number
}

export type Headers = {
    zakladka?: string,
    pole?: string,
    wpisanaWartosc?: string,
    komunikat?: string
}